export const POLICYCOLLECTIONS_RESET_STATE = 'POLICYCOLLECTIONS_RESET_STATE';
export const POLICYCOLLECTIONS_CURRENT_ITEM = 'POLICYCOLLECTIONS_CURRENT_ITEM';

export const POLICYCOLLECTIONS_REQUEST_LOADING = 'POLICYCOLLECTIONS_REQUEST_LOADING';
export const POLICYCOLLECTIONS_REQUEST_SUCCESS = 'POLICYCOLLECTIONS_REQUEST_SUCCESS';
export const POLICYCOLLECTIONS_REQUEST_FAILED = 'POLICYCOLLECTIONS_REQUEST_FAILED';

export const POLICYCOLLECTIONS_CURRENT_ACTION = 'POLICYCOLLECTIONS_CURRENT_ACTION';
export const POLICYCOLLECTIONS_RESET_ACTION = 'POLICYCOLLECTIONS_RESET_ACTION';